import React, { useState } from 'react';
import {
  Box,
  Button,
  Container,
  Typography,
  Paper,
  FormControlLabel,
  Checkbox,
  Alert,
  CircularProgress,
  Divider,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const ConsentSMS = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [preferences, setPreferences] = useState({
    sms_notifications: false,
    marketing_sms: false,
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    setPreferences(prev => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      // TODO: Implement API call to update preferences
      await new Promise(resolve => setTimeout(resolve, 1000)); // Simulated API call
      setSuccess(t('preferencesUpdated'));
    } catch (err: any) {
      setError(err.message || t('updateFailed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, mb: 4 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography component="h1" variant="h5" align="center" gutterBottom>
            {t('smsConsentManagement')}
          </Typography>

          <Typography variant="body1" sx={{ mb: 3 }}>
            {t('smsConsentDescription')}
          </Typography>

          <Alert severity="info" sx={{ mb: 3 }}>
            {t('smsOptOutInfo')}
          </Alert>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          {success && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {success}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              {t('notificationPreferences')}
            </Typography>

            <FormControlLabel
              control={
                <Checkbox
                  name="sms_notifications"
                  checked={preferences.sms_notifications}
                  onChange={handleChange}
                />
              }
              label={t('smsNotifications')}
            />

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ mb: 2 }}>
              {t('marketingPreferences')}
            </Typography>

            <FormControlLabel
              control={
                <Checkbox
                  name="marketing_sms"
                  checked={preferences.marketing_sms}
                  onChange={handleChange}
                />
              }
              label={t('marketingSms')}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3 }}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : t('savePreferences')}
            </Button>
          </form>
        </Paper>
      </Box>
    </Container>
  );
};

export default ConsentSMS; 